module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "library-view"
  }, [_c('div', {
    staticClass: "page-contain view-meeting-plan"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.addNewOrEditData,
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议名称"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("系统选择"), _c('common-tooltip', {
    attrs: {
      "tipCode": "8"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingSystem', _vm.addNewOrEditData.meetingSystem)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否网络会议"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议性质"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp)))])])], 1), _vm._v(" "), (_vm.meetingSystemType != 'GSD') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1会议类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingType', _vm.addNewOrEditData.meetingType)))])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD项目类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdType', _vm.addNewOrEditData.meetingGsdType)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD细类"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + _vm.addNewOrEditData.meetingGsdType, _vm.addNewOrEditData.meetingGsdSubType)))])])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Depart', _vm.addNewOrEditData.departId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MedicalField', _vm.addNewOrEditData.medicalField)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Teams', _vm.addNewOrEditData.teamL4)))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "治疗领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('TreatmentArea', _vm.addNewOrEditData.treatmentArea)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "疾病领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('DiseaseArea', _vm.addNewOrEditData.diseaseArea)))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Product', _vm.addNewOrEditData.productId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "公司战略"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('CompanyStrategy', _vm.addNewOrEditData.companyStrategy)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "策略重点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.strategyKeynoteName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'A1' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'A1',
      "label": "治疗领域业务结果"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultName))])])], 1), _vm._v(" "), (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0) ? _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "治疗领域业务结果（自定义描述）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultDes))])])], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "开始日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingBeginDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "结束日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingEndDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "会议时段"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingTimeInt', _vm.addNewOrEditData.meetingTimeInt)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "国家"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.countryName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "省份"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.provinceName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "城市"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.cityName))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD' || _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0) ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0,
      "label": "会议地点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingPlace))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [(_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "受赠方类型(GSD系统)"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.recipientSocietyOrHospital),
      callback: function($$v) {
        _vm.recipientSocietyOrHospital = $$v
      },
      expression: "recipientSocietyOrHospital"
    }
  }, [_c('el-radio', {
    staticClass: "tooltip-header-text",
    attrs: {
      "label": 1
    }
  }, [_vm._v("受赠学会"), _c('common-tooltip', {
    attrs: {
      "tipCode": "11"
    }
  })], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("医院")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("患者组织")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("其他")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital) ? _c('el-row', {
    staticClass: "recipientSociety-input"
  }, [_c('el-col', [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.recipientSocietyStr || _vm.addNewOrEditData.universityStr || _vm.addNewOrEditData.patientOrgStr || _vm.addNewOrEditData.otherStr))])])], 1) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType == 'A1' || !_vm.recipientSocietyOrHospital) ? _c('div', [_c('el-row', [(!_vm.isOneHospital()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院总数"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.moreThenOneHospital),
      callback: function($$v) {
        _vm.moreThenOneHospital = $$v
      },
      expression: "moreThenOneHospital"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("一家")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("两家及以上")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "hospitalLevelId"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("医院层级"), _c('common-tooltip', {
    attrs: {
      "tipCode": "9"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalLevelName))])])], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院数量",
      "prop": 'extendData.hospitalInfos.' + _vm.index + '.hospitalCount'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalCount))])])], 1) : _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院",
      "prop": "hospitalId"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalName))])])], 1)], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('div', _vm._l((_vm.addNewOrEditData.extendData.hospitalInfos), function(hospital, index) {
    return _c('div', {
      key: index,
      staticClass: "more-tab-div"
    }, [_c('el-row', {
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      attrs: {
        "required": "",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalLevelId'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("医院层级"), _c('common-tooltip', {
      attrs: {
        "tipCode": "9"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(hospital.hospitalLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      attrs: {
        "required": "",
        "label": "医院数量",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalCount'
      }
    }, [_c('label', [_vm._v(_vm._s(hospital.hospitalCount))])])], 1)], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "科室"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Office', _vm.addNewOrEditData.offices)))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否包含讲者"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.includeSpeaker ? '是' : '否'))])])], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD'
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("讲者级别"), _c('common-tooltip', {
    attrs: {
      "tipCode": "10"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "讲者人数"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerCount))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('div', {
    staticClass: "more-tab-div"
  }, _vm._l((_vm.addNewOrEditData.extendData.speakerInfos), function(speaker, index) {
    return _c('el-row', {
      key: index,
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("讲者级别"), _c('common-tooltip', {
      attrs: {
        "tipCode": "10"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(speaker.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD',
        "label": "讲者人数"
      }
    }, [_c('label', [_vm._v(_vm._s(speaker.speakerCount))])])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "参会人数（外）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.attendCount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "罗氏员工人数（内）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.rocheCount))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("会议总预算"), _c('common-tooltip', {
    attrs: {
      "tipCode": "12"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.totalAmount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "成本中心"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.costCenter + ' ' + _vm.addNewOrEditData.costCenterName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "WBS code"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.wbsCode))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.a1Amount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.gsdAmount))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "会议申请人"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingOrganizerCnname + ' ' + _vm.addNewOrEditData.meetingOrganizerName))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "approval-workflow-title"
  }, [_vm._v("\n                  审批流\n                  "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, _vm._l((_vm.addNewOrEditData.nodeList), function(node) {
    return _c('el-row', {
      key: node.id
    }, [_c('el-col', {
      staticClass: "approval-workflow"
    }, [_c('el-form-item', {
      staticClass: "not-required",
      attrs: {
        "label": node.isAuthorized === 0 ? node.nodeLevel + '【授权审批】' : node.nodeLevel,
        "prop": "treatAreaResult"
      }
    }, [_c('label', [_vm._v(_vm._s(node.realName) + " " + _vm._s(node.username) + " " + _vm._s(node.createTime) + " " + _vm._s(node.isAuthorized === 0 ? ("（" + (node.licensorName) + "授权）") : ''))]), _vm._v(" "), _c('span', {
      class: ['approval-status', _vm.approvalStatusClass(node.meetStatus)]
    }, [_vm._v(_vm._s(node.statusName))])]), _vm._v(" "), (node.remark) ? _c('el-form-item', {
      staticClass: "not-required"
    }, [_c('label', [_vm._v(_vm._s(node.remark))])]) : _vm._e()], 1)], 1)
  }), 1)])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b4e872ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4e872ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/meetingplan/library/view/index.vue
// module id = 1601
// module chunks = 7